import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import { TranslationKey } from '../i18n/translations';
import { SupportedLanguage } from '../types';
import { useSettings } from '../contexts/SettingsContext';

interface LoadingAIResponseChatProps {
  getTranslation: (key: TranslationKey, lang: SupportedLanguage) => string;
}

export const LoadingAIResponseChat: React.FC<LoadingAIResponseChatProps> = ({
  getTranslation,
}) => {
  const { interfaceLanguage } = useSettings();

  return (
    <View style={styles.container}>
      <View style={styles.loadingCard}>
        <ActivityIndicator size="small" color="#666" style={styles.spinner} />
        <Text style={styles.loadingText}>
          {getTranslation('waitingForAI', interfaceLanguage)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 12,
    maxWidth: '80%',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    elevation: 2,
  },
  spinner: {
    marginRight: 12,
  },
  loadingText: {
    fontSize: 14,
    color: '#666',
    fontWeight: '500',
  },
});
